import { observable } from '@legendapp/state';
import { zodI18n } from '@visualizer/schemas';

import { BFFAssetResponse, BFFResponse, I18nResponse } from './types/store-types';

interface RootStore {
	translations: I18nResponse['translations'];
	bffData: BFFResponse;
	isLoaded: {
		translations: boolean;
		bff: boolean;
	};
	currentModel: [string, BFFAssetResponse];
	currentVariant: [string, string[], string];
	currentModelNodeId?: string;
}

const translationsSchema = zodI18n.shape.translations;

const createDefaultTranslations = (): I18nResponse['translations'] => translationsSchema.parse({});
const createDefaultI18n = (): I18nResponse => ({
	api_version: '',
	application: '',
	language: '',
	tenant: '',
	translations: createDefaultTranslations()
});

export const rootStore = observable<RootStore>({
	translations: createDefaultTranslations(),
	bffData: {
		assets: {} as Record<string, BFFAssetResponse>,
		i18n: createDefaultI18n(),
		warnings: [],
		errors: []
	},
	isLoaded: {
		translations: false,
		bff: false
	},
	currentModel: ['', {} as BFFAssetResponse],
	currentVariant: ['', [], ''],
	currentModelNodeId: undefined
});

export const rootStoreActions = {
	setTranslations: (translations: I18nResponse['translations'] | null) => {
		rootStore.translations.set(translations ?? createDefaultTranslations());
		rootStore.isLoaded.translations.set(true);
	},
	setBffData: (data: BFFResponse) => {
		rootStore.bffData.set(data);
		rootStore.isLoaded.bff.set(true);
	},
	setModelData: (data: [string, BFFAssetResponse]) => {
		rootStore.currentModel.set(data);
	},
	setVariantData: (data: [string, string[], string]) => {
		rootStore.currentVariant.set(data);
	},
	setCurrentModelNodeId: (nodeId?: string) => {
		rootStore.currentModelNodeId.set(nodeId);
	}
};
